export default {
  icon: {
    width: '1.25rem',
  },
  toggle: {
    padding: {
      top: '0.6875rem',
      right: '0.75rem',
      bottom: '0.6875rem',
      left: '0.75rem',
    },
    border: {
      thickness: '0.0625rem',
      radius: 0,
      style: 'solid',
    },
  },
  day: {
    padding: {
      top: '0.625rem',
      right: '0.625rem',
      bottom: '0.625rem',
      left: '0.625rem',
      mobile: {
        top: '0.5rem',
        right: '0.5rem',
        bottom: '0.5rem',
        left: '0.5rem',
      },
    },
    border: {
      thickness: '0.0625rem',
      style: 'solid',
      color: '#E5E5E5',
    },
    hover: {
      background: '#F2F2F2',
    },
  },
  today: {
    border: {
      width: '0.125rem',
      style: 'solid',
      color: '#323232',
    },
  },
  selected: {
    background: '#323232',
    color: '#FFFFFF',
  },
  calendar: {
    border: {
      width: '0.1875rem',
    },
  },
  header: {
    margin: {
      top: '1.125rem',
      bottom: '0.75rem',
      mobile: {
        bottom: '2rem',
      },
    },
  },
  button: {
    border: {
      radius: '3.125rem',
      thickness: '0.0625rem',
      style: 'solid',
    },
    width: '1.5rem',
    height: '1.5rem',
    svg: {
      width: '0.9375rem',
      height: '0.9375rem',
      mobile: {
        height: '1.25rem',
        width: '1.25rem',
      },
    },
    margin: {
      left: '0.75rem',
      right: '0.75rem',
      mobile: {
        left: '2rem',
        right: '2rem',
      },
    },
    mobile: {
      height: '2rem',
      width: '2rem',
    },
  },
  container: {
    padding: {
      top: '1.25rem',
      bottom: '1.25rem',
    },
    mobile: {
      padding: {
        top: '6rem',
      },
    },
  },
  close: {
    mobile: {
      padding: {
        top: '0.9375rem',
        right: '0.9375rem',
        bottom: '0.9375rem',
        left: '0.9375rem',
      },
      inside: {
        margin: {
          right: '0.9375rem',
        },
      },
    },
    top: '0.625rem',
    right: '0.625rem',
    border: {
      radius: '3.125rem',
    },
    width: '1.25rem',
    height: '1.25rem',
    svg: {
      width: '0.875rem',
      height: '0.875rem',
      mobile: {
        width: '1.5rem',
        height: '1.5rem',
      },
    },
  },
  border: {
    thickness: '1px',
    style: 'solid',
    color: '#e5e5e5',
  },
};
